/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var config = require('../config'),
    Wamp = require('cjs-wamp'),
    Emitter = require('cjs-emitter'),
    Content = require('./video.class'),
    getDeviceInfo = require('./platforms.info'),
    parserAElement = document.createElement('a'),
    api = new Emitter(),
    contentData = [],
    connection;

/**
 * Connection type with websocket
 *
 * @type {number}
 */
api.CONNECTION_WEB_SOCKET = 1;

/**
 * Connection type with long polling
 *
 * @type {number}
 */
api.CONNECTION_LONG_POLLING = 2;

api.connectionType = 0;

function saveAllData () {
    core.plugins.ufsJson.save({
        id: config.user.id,
        wsUri: config.webSocket.uri,
        content: contentData
    });
}


function contentAddHandler ( dataArray, callback ) {

    dataArray = dataArray.map(function ( element ) {
        return new Content(element);
    });
    contentData = dataArray.concat(contentData);
    api.emit('share', dataArray);

    // in smart tv's and other non mag platforms we can save data immediately
    if ( PLATFORM !== 'MAG' ) {
        saveAllData();
    }

    callback && callback();
}


function startWebSocketConnection () {
    var wsUri = config.webSocket.uri + '/' + config.user.id,
        reconnectCount = 0,
        ws;

    console.log('ws uri: ' + wsUri);

    api.connectionType = api.CONNECTION_WEB_SOCKET;

    function errorHandler () {
        var xhr = new XMLHttpRequest(),
            url = config.httpServer.url + ':' + config.httpServer.port + '/reconnect?id=' + config.user.id;

        console.log(url);
        xhr.open('GET', url);
        xhr.onload = function () {
            var response = xhr.responseText;

            try {
                response = JSON.parse(response);
                if ( response.uri ) {
                    config.webSocket.uri = response.uri;
                    startWebSocketConnection();
                    saveAllData();
                }
            } catch ( error ) {
                // hmmmm
                console.log(error);
            }

        };
        xhr.onerror = function () {
            console.log(xhr);
        };

        xhr.send();
    }


    function connect () {
        ws = new WebSocket(wsUri);
        ws.onerror = function () {
            console.log('error ws');
        };
        ws.onclose = function () {
            console.log('ONCLOSE        ++++++');
            if ( reconnectCount++ < 3 ) {
                setTimeout(connect, 1500);
            } else {
                errorHandler();
            }
        };
        ws.onopen = function () {
            reconnectCount = 0;
        };


        connection = new Wamp(ws);
        connection.on('share', contentAddHandler);
        window.qq = connection;
    }


    connect();

}

window.addEventListener('unload', function () {

    if ( api.connectionType === api.CONNECTION_WEB_SOCKET ) {
        connection.socket.close();
    }

    saveAllData();
});

api.parseUriString = function ( uri ) {
    parserAElement.href = uri;

    return {
        protocol: parserAElement.protocol,
        port: parserAElement.port,
        host: parserAElement.hostname
    };
};

/**
 * Start websocket connection or use long polling as fallback if needed.
 */
function startConnection () {
    var wsUri,
        pollUri;

    // if we work over proxy we must use long polling instead web sockets
    if ( config.forceLongPolling ) {
        wsUri = api.parseUriString(config.webSocket.uri);
        pollUri = 'http://' + wsUri.host + ':' + (Number(wsUri.port) - 80) + '/shares/' + config.user.id;

        poll(pollUri); //eslint-disable-line
    } else {
        startWebSocketConnection();
    }

}

/**
 * Get user data.
 *
 * @param {Function} callback - callback after getting UID
 */
api.getUID = function ( callback ) {
    var xhr, url;

    getDeviceInfo(function ( deviceInfo ) {
        core.plugins.ufsJson.load(function ( error, data ) {
            var index, args;


            if ( !error && data && data.id && data.wsUri ) {

                config.user.id = data.id;
                config.webSocket.uri = data.wsUri;
                if ( data.content ) {
                    for ( index = 0; index < data.content.length; index++ ) {
                        contentData.push(new Content(data.content[index]));
                    }
                    api.emit('share', contentData);
                }

                startConnection();
                callback(false);
            } else {
                args = '?type=' + deviceInfo.type;

                args += '&model=' + deviceInfo.model;

                // try to get new uid
                xhr = new XMLHttpRequest();
                url = config.httpServer.url + ':' + config.httpServer.port + '/register' + args;
                console.log(url);

                xhr.open('GET', url);
                xhr.onload = function () {
                    var responseData = xhr.responseText;

                    try {
                        responseData = JSON.parse(responseData);
                        config.user.id = responseData.id;
                        config.webSocket.uri = responseData.uri;
                        core.plugins.ufsJson.save({
                            id: config.user.id,
                            wsUri: config.webSocket.uri
                        });
                        callback(false);
                        startConnection();
                    } catch (error) {
                        callback(false);
                    }
                };

                xhr.onerror = function () {
                    callback(true);
                };
                xhr.send();
            }
        });
    });
};

/**
 * Start long polling.
 *
 * @param {string} url - url to send xhr
 */
function poll ( url ) {
    var xhr = new XMLHttpRequest();

    function handle () {
        var data;
        // process data here...

        try {
            data = JSON.parse(xhr.responseText);
            if ( data && data.length ) {
                contentAddHandler(data);
            }
        } catch ( error ) {
            console.log(error, 'error');
        }

        poll(url);
    }

    xhr.open('GET', url);

    xhr.timeout = 15 * 60 * 1000;
    xhr.onload = handle;
    xhr.ontimeout = handle;
    xhr.onerror = handle;

    xhr.send();
    api.connectionType = api.CONNECTION_LONG_POLLING;
}

api.deleteContent = function ( deleteContent ) {
    contentData = contentData.filter(function ( element ) {
        return element !== deleteContent;
    });

    if ( PLATFORM !== 'MAG' ) {
        saveAllData();
    }
};

api.saveState = saveAllData;

module.exports = api;
